import React, { useCallback } from 'react';
import { observer } from 'owa-mobx-react';
import { Button, Tooltip } from '@fluentui/react-components';
import {
    isCopilotResultsTable,
    getStore,
    getListViewState,
    type TableView,
} from 'owa-mail-list-store';
import { getMailboxInfo } from 'owa-mail-mailboxinfo';
import selectFolder from 'owa-mail-folder-forest-actions/lib/actions/selectFolder';
import { lazySwitchToPreviousTable } from 'owa-mail-table-loading-actions';
import classnames from 'owa-classnames';
import {
    folderTab,
    folderTabNotSelected,
    folderTabText,
    full,
    medium,
    compact,
} from './MailListHeaderSecondRow.scss';
import { getDensityModeCssClass } from 'owa-fabric-theme';

export interface FolderHeaderTabProps {
    text?: string;
    tableView: TableView | undefined;
    posinset?: number;
    setsize?: number;
}

const FolderHeaderTab: React.FunctionComponent<FolderHeaderTabProps> = observer(
    function FolderHeaderTab({ text, tableView, posinset, setsize }: FolderHeaderTabProps) {
        const activeTableView = getStore().tableViews.get(getListViewState().selectedTableViewId);
        const isCopilotResultsActive = isCopilotResultsTable(activeTableView?.tableQuery);
        const densityModeString = getDensityModeCssClass(full, medium, compact);

        const onClick = useCallback(() => {
            if (isCopilotResultsActive && activeTableView) {
                lazySwitchToPreviousTable.importAndExecute(getMailboxInfo(activeTableView));
            } else {
                const folderId = tableView?.tableQuery?.folderId;
                if (folderId) {
                    selectFolder(
                        folderId,
                        'primaryFolderTree' /* folderTreeType */,
                        'FolderHeader' /* actionSource */
                    );
                }
            }
        }, [isCopilotResultsActive, tableView, activeTableView]);

        if (!text || !tableView) {
            return null;
        }

        return (
            <Tooltip content={text} relationship="label">
                <Button
                    className={classnames(
                        folderTab,
                        isCopilotResultsActive && folderTabNotSelected,
                        densityModeString
                    )}
                    onClick={onClick}
                    role="tab"
                    aria-selected={!isCopilotResultsActive}
                    aria-posinset={posinset}
                    aria-setsize={setsize}
                >
                    <span className={folderTabText}>{text}</span>
                </Button>
            </Tooltip>
        );
    },
    'FolderHeaderTab'
);

export default FolderHeaderTab;
